<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1">
        <span slot="label">待分配订单</span>
        <waitDistribution />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">已分配订单</span>
        <readyDistribution />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import waitDistribution from './components/waitDistribution.vue';
import readyDistribution from './components/readyDistribution.vue';
export default {
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    waitDistribution,
    readyDistribution
  },
  props: {},
  data () {
    return {
      tabsActive: '1'
    };
  },
  computed: {},
  mounted () {},
  methods: {}
};
</script>

<style>

</style>
